import { render, staticRenderFns } from "./single_sentence_writing.vue?vue&type=template&id=3752097c&scoped=true"
import script from "./single_sentence_writing.vue?vue&type=script&lang=js"
export * from "./single_sentence_writing.vue?vue&type=script&lang=js"
import style0 from "./single_sentence_writing.vue?vue&type=style&index=0&id=3752097c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3752097c",
  null
  
)

export default component.exports